<script setup lang="ts">
import { computed } from 'vue';
import type { IconifyIconProperties } from 'iconify-icon';

type Props = IconifyIconProperties;

const props = defineProps<Props>();
const propsWithValue = computed(() =>
  Object.keys(props)
    .filter(k => props[k] !== undefined)
    .reduce((obj, k) => {
      obj[k] = props[k];
      return obj;
    }, { noobserver: true } as Props),
);
</script>

<template>
  <iconify-icon
    v-bind="propsWithValue"
    class="align-middle"
  />
</template>
